import React, { FC } from 'react';
import classnames from 'classnames';

import styles from './Profile.module.css';

interface AvatarWrapper {
    className: string;
    children: React.ReactElement;
    avatarIcon: React.ReactElement;
    isReversedDisplay?: boolean;
    isFocused?: boolean;
}

const AvatarWrapper: FC<AvatarWrapper> = ({
    className,
    children,
    isReversedDisplay,
    avatarIcon,
    isFocused,
}) => (
    <div
        className={classnames(styles.wrapper, className, {
            isReversedDisplay,
            isFocused,
        })}
    >
        {avatarIcon}
        {children}
    </div>
);

interface AvatarWithBadgesProps extends AvatarWrapper {
    goldenStatus?: boolean;
}

export const AvatarWithBadges: FC<AvatarWithBadgesProps> = ({
    goldenStatus,
    className,
    ...rest
}) => {
    if (goldenStatus) {
        return (
            <div className={classnames(styles.withCrownRoot, className)}>
                <div className={styles.crown} />

                <AvatarWrapper {...rest} className={styles.avatarWithCrown} />
            </div>
        );
    }

    return <AvatarWrapper {...rest} className={className} />;
};
